// Base path for the in-app Help manual.
//
// CUTOVER DONE (2026-06-24): the manual was built out at the temporary /help2 path
// while the backend LegacyRedirectMiddleware (Mike's lane) still 301-redirected
// /help and /help/* to the old Roadkill wiki. Those redirects have been dropped, so
// the manual now lives at its real home, /help. Any /help2 links shared during the
// build-out are caught by a client-side /help2 + /help2/* → /help redirect in
// app/router.tsx.
export const HELP_BASE = '/help'

export const helpPath = (slug?: string) => (slug ? `${HELP_BASE}/${slug}` : HELP_BASE)
